import React from 'react';
import { Router } from 'react-router-dom';
import history from './utils/history';
import AppProviders from './AppProviders';
import Scripts from './Scripts';
import ScrollToTop from './ScrollToTop';
import ErrorHandler from './ErrorHandler';
import HistoryRecorder from './HistoryRecorder';
import Routes from './bundles/common/components/Routes';
import './bundles/common/components/inputs'; // Import inputs so they are not code split (decreases build time a ton)
import SEO from './bundles/common/components/SEO';
import { useServiceWorkerUpdate } from './utils/useServiceWorkerUpdate';

function App() {
  const { showReload, reloadPage } = useServiceWorkerUpdate();

  return (
    <AppProviders>
      <SEO />
      <Scripts />
      <Router history={history}>
        <HistoryRecorder>
          <ErrorHandler>
            <ScrollToTop />
            <Routes />
          </ErrorHandler>
        </HistoryRecorder>
      </Router>

      {showReload && (
        <div
          style={{
            position: 'fixed',
            bottom: '10px',
            left: '20px',
            background: '#222',
            color: '#fff',
            padding: '7px 20px',
            textAlign: 'center',
            zIndex: 1000,
            borderRadius: '4px',
          }}
        >
          A new version is available.
          <button onClick={reloadPage} className='ant-btn ant-btn-primary ant-btn-sm' style={{ marginLeft: 16 }}>
            Reload
          </button>
        </div>
      )}
    </AppProviders>
  );
}

export default App;
